var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-page"},[(_vm.currentStage === 'registration')?_c('registration'):(_vm.currentStage === 'tasks')?_c('tasks'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }